import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';

import { CoreModule } from '@/app/core/core.module';
import { LoaderComponent } from '@/app/core';
import { AuthGuard } from '@/app/core/guards/auth.guard';
import { RevenueService, SummaryComponent, SummaryService } from './';
import { FeatureFlagModule } from '@/app/core/feature-flags/feature-flag.module';
import { HtmlTooltipDirective } from '@/app/core/html-tooltip/html-tooltip.directive';

const root = 'summary';
const summaryroutes: Routes = [
  {
    path: root,
    component: SummaryComponent,
    data: { title: 'main.tabs.summary.page_title' },
    canActivate: [AuthGuard],
    runGuardsAndResolvers: 'always',
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(summaryroutes),
    CommonModule,
    CoreModule,
    FeatureFlagModule,
    MatTooltipModule,
    LoaderComponent,
    HtmlTooltipDirective,
  ],
  declarations: [SummaryComponent],
  providers: [SummaryService, RevenueService, AuthGuard],
  exports: [SummaryComponent, RouterModule],
})
export class SummaryModule {}
